<template>
  <div class="container">
    <notifications></notifications>

    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <card class="card-login card-white">
            <template slot="header">
              <img src="img/card-primary.png" alt="" />
              <h1 class="card-title">Log in</h1>
            </template>

            <div>
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ passed, failed, errors }"
              >
              <base-input
                required
                v-model="email"
                type="email"
                placeholder="Email"
                addon-left-icon="tim-icons icon-email-85"
                :error="errors[0]"
                :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
              </base-input>
             </ValidationProvider>

             <base-input
               required
               v-model="password"
               placeholder="Password"
               addon-left-icon="tim-icons icon-lock-circle"
               type="password">
             </base-input>
            </div>

            <div slot="footer">
              <base-button native-type="submit" type="primary" class="mb-3" size="lg" block>
                Login
              </base-button>
              <div class="pull-left">
                <h6>
                  <router-link class="link footer-link" :to="{ path: 'register', query : {redirect: $route.query.redirect }}">
                    Create Account
                  </router-link>
                </h6>
              </div>
              <div class="pull-right">
                <h6>
                  <router-link class="link footer-link" to="/forgot">
                    Forgot password?
                  </router-link>
                </h6>
              </div>
            </div>
          </card>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>

import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import auth from "./../../pbg/auth";

extend("email", email);
extend("min", min);

extend("required", required);

export default {
  data() {
    return {
      email: localStorage.getItem('lastEmail') || "",
      password: ""
    };
  },
  methods: {
    submit() {
      auth.login(this.email, this.password, result => {
        if (!result.authenticated) {
          this.$notify({verticalAlign: 'top', horizontalAlign: 'center', message: result.errorMessage})
        } else {
          this.$router.replace(this.$route.query.redirect || '/')
        }
      })
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
